(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moo-collection-intro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    if (root.dataset.mooClampReady === '1') return;
    root.dataset.mooClampReady = '1';
    const text = root.querySelector('.moo-cintro__text');
    const btn = root.querySelector('[data-moo-clamp-toggle]');
    const more = root.querySelector('[data-moo-clamp-more]');
    const less = root.querySelector('[data-moo-clamp-less]');
    if (!text || !btn) return;

    root.classList.add('is-clamped');
    const overflows = text.scrollHeight - text.clientHeight > 2;
    if (!overflows) {
      root.classList.remove('is-clamped');
      return;
    }
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const clamped = root.classList.toggle('is-clamped');
      more.hidden = !clamped;
      less.hidden = clamped;
      btn.setAttribute('aria-expanded', String(!clamped));
    });
  };
  const init = () => document.querySelectorAll('[data-moo-clamp]').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moo-footer"] && !Shopify.designMode) return;
  try {
    
/* Footer menus are <details open> in the markup so desktop and no-JS visitors
   always see the links. Collapse them only on mobile. */
(() => {
  const mq = matchMedia('(max-width: 749px)');
  const sync = () => {
    document.querySelectorAll('.moo-foot__col').forEach((d) => {
      d.open = !mq.matches;
    });
  };
  sync();
  mq.addEventListener('change', sync);
})();

document.querySelectorAll('[data-moo-foot]').forEach((root) => {
  const icon = root.querySelector('[data-moo-moon]');
  const label = root.querySelector('[data-moo-moon-text]');
  if (!icon || !label) return;
  const SYN = 29.53058867;
  const KNOWN = Date.UTC(2000, 0, 6, 18, 14);
  const age = ((Date.now() - KNOWN) / 86400000) % SYN;
  const frac = age / SYN;
  const NAMES = ['new moon', 'waxing crescent', 'first quarter', 'waxing gibbous', 'full moon', 'waning gibbous', 'last quarter', 'waning crescent'];
  const idx = Math.round(frac * 8) % 8;
  const r = 6;
  const c = 7;
  const il = (1 - Math.cos(2 * Math.PI * frac)) / 2;
  const d = frac < 0.5 ? 1 : 0;
  const x = r * (1 - 2 * il);
  const sweep = (d === 1 ? x > 0 : x < 0) ? 1 : 0;
  icon.innerHTML = '<circle cx="' + c + '" cy="' + c + '" r="' + r + '" fill="none" stroke="currentColor" stroke-width=".9" opacity=".55"/>' +
    '<path d="M ' + c + ' ' + (c - r) + ' A ' + r + ' ' + r + ' 0 0 ' + d + ' ' + c + ' ' + (c + r) + ' A ' + Math.abs(x) + ' ' + r + ' 0 0 ' + sweep + ' ' + c + ' ' + (c - r) + ' Z" fill="currentColor"/>';
  label.textContent = label.textContent + ' — ' + NAMES[idx];
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moo-instagram"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-moo-ig]').forEach((root) => {
  const stream = root.querySelector('[data-moo-ig-stream]');
  const track = root.querySelector('[data-moo-ig-track]');
  if (!stream || !track) return;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let x = 0;
  let speed = reduced ? 0 : parseFloat(root.dataset.speed || '0.4');
  let paused = false;
  let half = 0;
  let drag = false;
  let startX = 0;
  let startOff = 0;
  let moved = 0;

  const measure = () => { half = track.scrollWidth / 2; };
  addEventListener('load', measure);
  addEventListener('resize', measure);
  measure();

  const wrap = () => {
    if (!half) return;
    if (x <= -half) x += half;
    if (x > 0) x -= half;
  };
  const apply = () => { track.style.transform = 'translateX(' + x + 'px)'; };

  (function tick() {
    if (!paused && half && speed) {
      x -= speed;
      wrap();
      apply();
    }
    requestAnimationFrame(tick);
  })();

  stream.addEventListener('mouseenter', () => { paused = true; });
  stream.addEventListener('mouseleave', () => { if (!drag) paused = false; });

  stream.addEventListener('pointerdown', (e) => {
    drag = true;
    paused = true;
    startX = e.clientX;
    startOff = x;
    moved = 0;
    stream.classList.add('dragging');
  });
  addEventListener('pointermove', (e) => {
    if (!drag) return;
    moved = Math.abs(e.clientX - startX);
    x = startOff + (e.clientX - startX);
    wrap();
    apply();
  });
  addEventListener('pointerup', () => {
    if (!drag) return;
    drag = false;
    stream.classList.remove('dragging');
    paused = false;
  });
  track.addEventListener('click', (e) => {
    if (moved > 6) e.preventDefault();
  });

  const step = () => {
    const pol = track.querySelector('.moo-ig__pol');
    if (!pol) return 0;
    return pol.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '0');
  };
  const glide = (target) => {
    const from = x;
    const delta = target - from;
    const t0 = performance.now();
    paused = true;
    (function anim(t) {
      const p = Math.min(1, (t - t0) / 450);
      const e = 1 - Math.pow(1 - p, 3);
      x = from + delta * e;
      wrap();
      apply();
      if (p < 1) requestAnimationFrame(anim);
      else paused = false;
    })(t0);
  };
  const prev = root.querySelector('[data-moo-ig-prev]');
  const next = root.querySelector('[data-moo-ig-next]');
  if (next) next.addEventListener('click', () => glide(x - step()));
  if (prev) prev.addEventListener('click', () => glide(x + step()));

  new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        root.classList.add('in');
        obs.disconnect();
        measure();
      }
    });
  }, { threshold: 0.15 }).observe(root);
  if (reduced) root.classList.add('in');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moo-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fill = async (root) => {
    if (root.dataset.mooRecsReady === '1') return;
    root.dataset.mooRecsReady = '1';
    if (root.querySelector('.moo-recs__track')) return;
    const url = root.dataset.url;
    if (!url) return;
    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-moo-recs]');
      if (fresh) root.innerHTML = fresh.innerHTML;
    } catch (e) {
      return;
    }
  };
  const init = () => document.querySelectorAll('[data-moo-recs]').forEach(fill);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moo-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wire = (root) => {
    if (root.dataset.mooRevReady === '1') return;
    const track = root.querySelector('[data-moo-rev-track]');
    const dots = root.querySelector('[data-moo-rev-dots]');
    if (!track || !dots) return;
    root.dataset.mooRevReady = '1';
    const buttons = [...dots.querySelectorAll('[data-moo-rev-dot]')];

    const paint = () => {
      const item = track.querySelector('.moo-rev__item');
      if (!item) return;
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      const i = step ? Math.round(track.scrollLeft / step) : 0;
      buttons.forEach((b, n) => b.classList.toggle('is-on', n === i));
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
    }, { passive: true });

    buttons.forEach((b, n) => b.addEventListener('click', () => {
      const item = track.querySelectorAll('.moo-rev__item')[n];
      if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }));

    paint();
  };

  const boot = () => document.querySelectorAll('.moo-rev--slider').forEach(wire);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
